export enum ImageActionSheetOptionID {
    FromPhotoAlbum = 'FROM_PHOTO_ALBUM',
    FromTencentDocument = 'FROM_TENCENT_DOCUMENT',
    FromLocalFile = 'FROM_LOCAL_FILE',
    Camera = 'CAMERA',
}
